<template>
    <div class="row projectForm">
        <div v-if="modalForm.isEmptyDiv">
            <div class="row">
                <div class="col-12" style="border-bottom: 1px solid #f3f3f3;">
                    <h4 style="color: #425976">Information</h4>
                </div>
                <div class="col-12 mt-2" style="font-size: 18px">
                    <span style="color: #6a85a7">You can add or update your password for your outsourcing projects.</span>
                </div>
            </div>
        </div>
        <div v-if="modalForm.isActiveProjectModal" class="border rounded-4 mx-lg-2" style="padding: 10px">
            <div v-if="projectForm.id != ''" class="row" style="padding: 5px;">
                <div class="col-10">
                    <h5>Edit Project</h5>
                </div>
            </div>
            <div v-else style="padding: 5px;">
                <h5>Add Project</h5>
            </div>
            <div class="pt-2" style="border-top: 1px solid #f3f3f3;padding: 10px">
                <div v-if="projectForm.id == ''">
                    <label class="form-label pt-2">Project Name</label>
                    <select class="form-select" v-model="projectForm.projectCode" placeholder="Please select ">


                      <option value="" disabled selected>Please Select a Project</option>
                        <option v-for="projectCode in projectsMyProject" :key="projectCode.id" selected
                                :value="projectCode.code">
                            {{ projectCode.name}}
                        </option>
                    </select>
                </div>
                <label class="form-label pt-2">Group Name</label>
                <div class="input-group">
                    <input type="text" class="form-control" name="groupName" placeholder="Group"
                           v-model="projectForm.groupName" required autocomplete="off">
                </div>
                <label class="form-label pt-2">User Name</label>
                <div class="input-group">
                    <input id="email" type="text" class="form-control" name="email" placeholder="User ID"
                           v-model="projectForm.loginId" required autocomplete="off">
                </div>
                <label class="form-label pt-2">Password</label>
                <div class="input-group pb-4">
                    <input id="password" class="form-control" name="password"
                           placeholder="Password" v-model="projectForm.password" required autocomplete="off">
                </div>
                <div v-if="projectForm.id != ''" class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
                    <button class="btn btn-success mt-3" @click="TryAddMyProject(projectForm)">
                        <font-awesome-icon icon="edit"/>
                        <span class="mx-1">Update</span>
                    </button>
                </div>
                <div v-else class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
                    <button class="btn mt-2" @click="TryAddMyProject(projectForm)"
                            style="background-color: #56759c;color: #ffffff">
                        <font-awesome-icon icon="save"/>
                        <span class="mx-1">Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        name: "ManageSideForm",
        props: ["projectForm", "modalForm"],
        methods: {
            ...mapActions('externalProject', ['getExternalInfos', 'getExternalInfo', 'AddExternalInfo']),
            ...mapActions('projects', ["getProjectOfUser"]),

            async TryAddMyProject(value) {
                try {
                    console.log(value)
                    console.log(value.userId)
                    value.userId = this.user.userId;
                    await this.AddExternalInfo(value)
                    this.$notify({title: "Success", type: "success", text: "Project succesfully adding."})
                    // this.addSegmentForm = {};
                    window.location.reload();
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                } finally {
                    this.getExternalInfos()
                }
            },
        },
        computed: {
            ...mapState('projects', ['projects', 'projectsOfUser']),
            ...mapState('auth', ['user']),

            projectsMyProject: function () {
                return this.projectsOfUser.filter((post) => {
                    return post.code != ('AUT' && 'OUT') && post.usesSingleSignOn == 0 && post.fStatus == 1 && post.code != 'MAP';
                });
            },
        },
        created() {
            this.getProjectOfUser();
        }
    }
</script>

<style scoped>

</style>
